/**
 * RivalryInvitesTab — iter87.6. Dedicated Rivalry-Admin tile for
 * "how new crewmates join". Hosts the Invite by Email card + the
 * pending-invite list. Pulled out of the shared Rivalry Settings
 * tab per operator direction (each thing worth doing gets its own
 * tile).
 */
import InviteByEmailCard from "@/components/InviteByEmailCard";

export default function RivalryInvitesTab({ league, leagueId, isLocked, onChanged }) {
    return (
        <div className="space-y-5" data-testid="rivalry-invites-tab">
            <div className="brutal-card-light p-3 flex items-start gap-3">
                <p className="text-xs text-zinc-300 leading-relaxed">
                    <strong className="text-cyber">Invite crewmates to the rivalry.</strong> Everyone you invite here can
                    join any tournament you run in this rivalry — invite codes carry across the whole season.
                </p>
            </div>
            <InviteByEmailCard
                leagueId={league?.id}
                league={league}
                isLocked={isLocked}
                onChanged={onChanged}
            />
        </div>
    );
}
